import { Input, Text,ModalBody } from '@chakra-ui/react';
import { handleResponse } from './utils';
import { getQuestionTemplateByQuestionType} from '../../../formControllers/utils';
const ModalQuestion = ({ props }) => {
  const stateProps = props.stateProps;
  const bulletModal = stateProps.bulletData.bulletModal;
  let buttonLabel =bulletModal.label.replace('~','_______');
  if(stateProps.bulletData.bulletGroup === 'freeform') {
    buttonLabel = 'Please enter your bullet below';
  }
  const sectionIndex = props.stateProps.sectionData.sectionIndex;//getResumeOrSectionIndex(props.stateProps,props.formikProps);
  let qObj = null;
  for (let i=0;i<props.sections.questions.length;i++) {
    qObj = props.sections.questions[i];
    if(qObj.qid === bulletModal.qid) {
      break;
    }
  }
  if(qObj && qObj.qid && qObj.question_type !== 'bullets') {
    stateProps.tempBullet = bulletModal.label.replace('~',bulletModal.buttonLabels[bulletModal.index][0]);
    return (
      getQuestionTemplateByQuestionType(props, qObj, sectionIndex)
    );
  } else {

    stateProps.tempBullet = bulletModal.buttonLabels[bulletModal.index];
    return (
      <ModalBody>
        <Text>{buttonLabel}</Text>
        <Input
          defaultValue={
            bulletModal.buttonLabels[
              bulletModal.index
              ]
          }
          onBlur={(e) =>
            handleResponse(e,stateProps)
          }
        />
      </ModalBody>
    )
  }
}



export default ModalQuestion;